import api from "@/shared/services/apiClient";

export interface SouserBuAccess {
  business_unit: string;
  granted_at: string;
  announcements_read?: boolean;
  announcements_write?: boolean;
}

export interface SouserRow {
  id: string;
  email: string;
  first_name: string;
  last_name: string;
  display_name: string | null;
  sending_org: string;
  country: string;
  position_title: string | null;
  primary_bu: string;
  is_active: boolean;
  created_at: string;
  last_seen: string | null;
  bu_access: SouserBuAccess[];
}

export interface CreateSouserPayload {
  email: string;
  first_name: string;
  last_name: string;
  display_name?: string;
  sending_org: string;
  country: string;
  position_title?: string;
  additional_bus?: string[];
  announcements_write?: boolean;
  announcements_read?: boolean;
}

export interface UpdateSouserPayload {
  first_name?: string;
  last_name?: string;
  display_name?: string | null;
  country?: string;
  position_title?: string | null;
}

export const souserService = {
  setAnnouncementsWrite: async (id: string, announcements_write: boolean) => {
    const res = await api.patch(`/souser/${id}/announcements-write`, { announcements_write });
    return res.data;
  },
  getAll: async (): Promise<SouserRow[]> => {
    const res = await api.get("/souser/list");
    return res.data;
  },

  create: async (data: CreateSouserPayload): Promise<{ message: string; record: SouserRow; warnings?: { step: string; message: string }[] }> => {
    const res = await api.post("/souser/create", data);
    return res.data;
  },

  update: async (id: string, data: UpdateSouserPayload): Promise<{ message: string; record: SouserRow; warnings?: { step: string; message: string }[] }> => {
    const res = await api.patch(`/souser/${id}`, data);
    return res.data;
  },

  toggleActive: async (id: string, is_active: boolean): Promise<{ message: string; record: { id: string; is_active: boolean } }> => {
    const res = await api.patch(`/souser/${id}/toggle`, { is_active });
    return res.data;
  },

  grantBuAccess: async (id: string, business_unit: string) => {
    const res = await api.post(`/souser/${id}/bu-access`, { business_unit });
    return res.data;
  },

  revokeBuAccess: async (id: string, bu: string) => {
    const res = await api.delete(`/souser/${id}/bu-access/${bu}`);
    return res.data;
  },

  delete: async (id: string): Promise<{ message: string }> => {
    const res = await api.delete(`/souser/${id}`);
    return res.data;
  },

  updateBuPermissions: async (id: string, businessUnit: string, announcements_read: boolean, announcements_write: boolean) => {
    const res = await api.patch(`/souser/${id}/bu-access/${businessUnit}/permissions`, {
      announcements_read,
      announcements_write,
    });
    return res.data;
  },

  resetPassword: async (id: string, new_password: string): Promise<{ message: string }> => {
    const res = await api.patch(`/souser/${id}/reset-password`, { new_password });
    return res.data;
  },

  getMe: async (): Promise<SouserRow> => {
    const res = await api.get("/souser/me");
    return res.data;
  },

  updateMe: async (data: { first_name?: string; last_name?: string; display_name?: string | null; position_title?: string | null }): Promise<{ message: string; record: SouserRow; warnings?: { step: string; message: string }[] }> => {
    const res = await api.patch("/souser/me", data);
    return res.data;
  },
};
